import React from 'react';
import { Link } from 'react-router-dom';
import { LockClosedIcon, HomeIcon } from '@heroicons/react/24/outline';

const AccessDenied = ({ pageName = 'this page' }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <div className="flex justify-center">
            <LockClosedIcon className="h-16 w-16 text-red-500" />
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Access Denied
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            You don't have permission to access <span className="font-semibold">{pageName}</span>
          </p>
          <p className="mt-4 text-sm text-gray-500">
            Your administrator has restricted access to this page. If you believe this is an error, please contact your administrator.
          </p>
        </div>

        <div className="mt-8 space-y-4">
          <Link
            to="/app/dashboard"
            className="w-full flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 transition-colors"
          >
            <HomeIcon className="h-5 w-5 mr-2" />
            Go to Dashboard
          </Link>

          <Link
            to="/app"
            className="w-full flex items-center justify-center px-4 py-3 border border-gray-300 text-base font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 transition-colors"
          >
            Back to Home
          </Link>
        </div>

        <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-md">
          <h3 className="text-sm font-medium text-blue-900">What can you do?</h3>
          <ul className="mt-2 text-sm text-blue-700 space-y-1 text-left">
            <li>• Contact your administrator to request access</li>
            <li>• Navigate to pages you have access to</li>
            <li>• Check your email for access changes</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
